import React, { useEffect, useState } from "react";
import { getCdpSegments } from "../../api";
import PanelTakeaway from "../shared/PanelTakeaway";

const SEGMENT_CONFIG = {
  Converters:       { color: "border-amber-500 bg-amber-50 dark:bg-amber-900/20", dot: "bg-amber-500", desc: "Completed a booking this period" },
  "Hot Leads":      { color: "border-emerald-500 bg-emerald-50 dark:bg-emerald-900/20", dot: "bg-emerald-500", desc: "Clicked Book Now but didn't finish" },
  "Ghost Demand":   { color: "border-orange-500 bg-orange-50 dark:bg-orange-900/20", dot: "bg-orange-500", desc: "High engagement, never clicked Book Now" },
  "Window Shoppers":{ color: "border-blue-500 bg-blue-50 dark:bg-blue-900/20", dot: "bg-blue-500", desc: "Keep coming back but never act" },
  Returning:        { color: "border-sky-400 bg-sky-50 dark:bg-sky-900/20", dot: "bg-sky-400", desc: "Came back at least once" },
  "Engaged New":    { color: "border-gray-400 bg-gray-50 dark:bg-gray-800/40", dot: "bg-gray-400", desc: "New visitor, 30+ seconds on site" },
  Bounced:          { color: "border-gray-300 bg-gray-50/50 dark:bg-gray-800/20", dot: "bg-gray-300", desc: "One page, under 30 seconds" },
};

export default function CdpVisitorSegments({ clientId, rangeStart, rangeEnd, includeBots = false, onSelectSegment, activeSegment, say }) {
  const [segments, setSegments] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!clientId || !rangeStart || !rangeEnd) return;
    let cancelled = false;

    const load = async () => {
      try {
        setLoading(true);
        const resp = await getCdpSegments(clientId, rangeStart, rangeEnd, { includeBots });
        if (!cancelled) setSegments(resp?.data || []);
      } catch (e) {
        console.error("CDP segments error:", e);
        if (!cancelled) setSegments([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => { cancelled = true; };
  }, [clientId, rangeStart, rangeEnd, includeBots]);

  if (loading) return <div className="text-sm text-gray-400 py-4 text-center">Loading segments...</div>;
  if (segments.length === 0) return null;

  return (
    <div>
      <PanelTakeaway panelKey="segments" say={say} />
      <h3 className="gi-panel-title text-gray-900 dark:text-white mb-3">Visitor Segments</h3>
      <div className="grid grid-cols-2 min-[1200px]:grid-cols-4 min-[1800px]:grid-cols-7 gap-3">
        {segments.map((s) => {
          const cfg = SEGMENT_CONFIG[s.segment] || SEGMENT_CONFIG["Bounced"];
          const isActive = activeSegment === s.segment;
          return (
            <button
              key={s.segment}
              type="button"
              onClick={() => onSelectSegment?.(isActive ? null : s.segment)}
              className={`rounded-xl border-l-4 p-3 text-left transition-all hover:shadow-sm ${cfg.color} ${
                isActive ? "ring-2 ring-[#32B1FF] ring-offset-1 dark:ring-offset-gray-950" : ""
              }`}
            >
              <div className="flex items-center gap-1.5 mb-1">
                <span className={`w-2 h-2 rounded-full ${cfg.dot}`}></span>
                <span className="text-xs font-semibold text-gray-800 dark:text-gray-200">{s.segment}</span>
              </div>
              <div className="text-lg font-bold text-gray-900 dark:text-white">{s.visitors}</div>
              <div className="text-[10px] text-gray-500 dark:text-gray-400">{s.pct}%</div>
              <div className="text-[10px] text-gray-400 dark:text-gray-500 mt-1 leading-tight">{cfg.desc}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
